import s from "./HomeHeroSection.module.scss";

const HomeHeroSection = () => {
  return (
    <section className={s.heroSection} id="heroSection">
      <h1>POWERING BUSINESS GROWTH WITH AI AND DATA MANAGEMENT</h1>
      <h2>Unlock the Power of Data with Aster Information Limited</h2>
    </section>
  );
};
export default HomeHeroSection;
